import { memo } from 'react';

import RejectIconSVG from '@/assets/reject-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IRejectIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={RejectIconSVG} {...props} />;

export const RejectIcon = memo(IRejectIcon) as typeof IRejectIcon;
